var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",class:[("btn__" + _vm.type + " btn-active__" + _vm.activeType),{'btn__disabled': _vm.disabled}],on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v("button")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }